import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ChatChannelListEffects } from './state/chat-channel-list.effects';
import { chatChannelListReducer } from './state/chat-channel-list.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('chatChannelList', chatChannelListReducer),
    EffectsModule.forFeature([ChatChannelListEffects]),
  ],
})
export class ChatChannelListStoreModule {}
